import { useState } from "react";
import _ from "lodash";

import { Button, Modal } from "../../ui";

const CopyPressDescription = props => {
  const [loading, setLoading] = useState(false);

  const copyPressDescriptionModalProps = {
    title: "Copy Press Description",
    scale: "sm",
    description: "Are you sure you wish to copy press description of artwork?",
    closeOnBackdrop: true,
    body: ({ closeModal }) => {
      const handleCopyDescription = async () => {
        const { artwork = {}, edition, currentSlide } = props;
        const { artists = [] } = artwork;
        const filteredArtists = artists.filter(artist => Boolean(artist.name));
        let description = "";

        try {
          setLoading(true);

          // artist names
          if (filteredArtists.length > 0) {
            description += _.join(
              filteredArtists.map(artist => artist.name),
              ", ",
            );
            description += "\n";
          }

          // artwork title
          if (artwork?.title) {
            description += artwork.title + "\n";
          }

          // edition year
          const editionYear = edition?.year || artwork?.editions?.[0]?.year;
          if (editionYear) {
            description += editionYear + "\n";
          }

          // artwork medium
          if (artwork?.medium) {
            description += artwork.medium + "\n";
          }

          // artwork dimensions
          if (artwork?.dimensions) {
            description += artwork.dimensions + "\n";
          }

          if (filteredArtists.length > 0) {
            description += _.join(
              filteredArtists.map(
                artist => artist?.copyright || "\u00A9 " + artist.name,
              ),
              ", ",
            );
            description += ". ";
          }

          if (artwork?.images?.[currentSlide]?.photoMaterial?.photographer) {
            description += `Photo \u00A9 ${artwork.images[currentSlide].photoMaterial.photographer}.`;
          }

          if (artwork?.images?.[currentSlide]?.photoMaterial?.credit) {
            description += ` Courtesy ${artwork.images[currentSlide].photoMaterial.credit}.`;
          }

          navigator.clipboard.writeText(description);
        } catch (err) {
          console.error("CopyPressDescription", err);
        } finally {
          setLoading(false);
          closeModal();
        }
      };

      return (
        <div className="mt-4 flex flex-col-reverse gap-3 sm:flex-row">
          <Button
            label={"Cancel"}
            action={"default"}
            onClick={() => {
              closeModal();
            }}
          />
          <Button
            disabled={loading}
            label={loading ? "Fetching description" : "Copy description"}
            onClick={handleCopyDescription}
          />
        </div>
      );
    },
  };

  return (
    <Modal {...copyPressDescriptionModalProps}>
      <Button label="Copy Press Description" className={"!w-32"} />
    </Modal>
  );
};

export default CopyPressDescription;
